import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {Route, useNavigate} from 'react-router-dom';
import {
    FormControl, InputLabel, MenuItem,
    Pagination, Select,
} from "@mui/material";
import {isMobile} from "react-device-detect";
import {NoteHistory} from "../../interface/noteHistory.interface";
import NoteListTable from "./table/NoteListTable";
import NoteContentDialog from "./NoteContentDialog";
import DeleteIcon from '@mui/icons-material/Delete';

interface State {
    noteHistoryList: NoteHistory[],
    totalCount: number,
    unReadCount: number,
    page: number,
    deleteNoteIdList: string[],
    openContent: boolean,
    selectedContent: NoteHistory,
}

export default function NoteBoxContent(props: { id: string }) {
    console.log('NoteBoxContent');
    const [state, setState] = useState<State>({
        noteHistoryList: [],
        totalCount: 0,
        unReadCount: 0,
        page: 1,
        deleteNoteIdList: [],
        openContent: false,
        selectedContent: {
            _id: "",
            content: "",
            createdAt: "",
            receiver: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""},
            receiverConfirmDate: new Date(),
            type: "",
            sender: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""},
        },
    });
    const navigate = useNavigate();

    let {id, workplace, no, page, club, department, keyword, searchType} = common.getQuery();


    useEffect(() => {
        getList();
    }, [props.id, page]);


    function getList() {
        /* 리스트 가지고 오기 */
        let url = '';
        axios.get(constance.api.getNoteList, {params: {type: props.id, page: page}}).then((value) => {
            if (value.data.success) {
                setState({
                    ...state,
                    noteHistoryList: value.data.noteHistoryList,
                    totalCount: Number(value.data.totalCount),
                    unReadCount: Number(value.data.unReadCount),
                    page: page,
                    deleteNoteIdList: Array.apply(null, new Array(value.data.noteHistoryList.length)).map(String.prototype.valueOf, ''),
                });
            }
        }).catch(reason => {
            alert(reason);
        });
    }

    /* 페이지 변경 */
    function changePagination(event: any, page: number) {
        if (page == 0) {
            page = event.target.value;
        }
        setState({
            ...state,
            page: page
        })
        navigate(`${config.url.noteBox}/${props.id}?page=${page}`);
    }

    /* 보낸 쪽지 삭제 */
    function deleteNote(deleteList?: string[]) {
        let list: string[] = [];
        if (!deleteList) {
            list = state.deleteNoteIdList.filter(value => value != '');
        } else {
            list = deleteList
        }


        axios.post(constance.api.deleteNote, {
            params: {
                type: props.id,
                deleteList: list,
                page: state.page
            }
        }).then(value => {
            if (value.data.success) {
                setState({
                    ...state,
                    noteHistoryList: value.data.noteHistoryList,
                    totalCount: Number(value.data.totalCount),
                    unReadCount: Number(value.data.unReadCount),
                    page: page,
                    deleteNoteIdList: Array.apply(null, new Array(value.data.noteHistoryList.length)).map(String.prototype.valueOf, ''),
                    openContent: false,
                });
            }
        })
    }


    function checkDeleteNote(event: React.ChangeEvent<HTMLInputElement>, index: number, note: NoteHistory) {
        event.stopPropagation();
        console.log(event);
        let checkedList: any = JSON.parse(JSON.stringify(state.deleteNoteIdList));
        if (event.target.checked) {
            checkedList[index] = note._id;
        } else {
            checkedList[index] = '';
        }
        setState({
            ...state,
            deleteNoteIdList: checkedList,
        })
    }


    let deleteCount = 0;
    if (state.deleteNoteIdList.length > 0) {
        let array = state.deleteNoteIdList.map(value => {
            return value == '' ? 0 : 1;
        })
        deleteCount = array.reduce((previousValue: any, currentValue: any) => {
            return previousValue + currentValue;
        })
    }

    function clickNote(note: NoteHistory) {
        if (props.id == constance.noteType.inBox) {
            axios.post(constance.api.readNote, {
                params: {
                    _id: note._id,
                    type: props.id,
                    page: state.page
                }
            }).then(value => {
                setState({
                    ...state,
                    noteHistoryList: value.data.noteHistoryList,
                    totalCount: Number(value.data.totalCount),
                    unReadCount: Number(value.data.unReadCount),
                    page: page,
                    deleteNoteIdList: Array.apply(null, new Array(value.data.noteHistoryList.length)).map(String.prototype.valueOf, ''),
                    openContent: true,
                    selectedContent: note
                })
            })
        }
    }


    let fontSize: any = isMobile? "subtitle2" :"subtitle1";

    return (
        <>
            <Box sx={{display: 'flex', width: 1, justifyContent: 'center'}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', mb: 2,
                }}>
                    <Box sx={{display: 'flex', mt: 2, width: 1, justifyContent: 'flex-start'}}>
                        <Typography variant={fontSize}>{props.id == constance.noteType.inBox? '받은쪽지함' : '보낸쪽지함'}</Typography>
                        <Typography variant={fontSize} sx={{ml: 1}}>{`(전체 ${state.totalCount}`}</Typography>
                        <Typography variant={fontSize} sx={{ml: 1}}>{`| 안 읽음 `}</Typography>
                        <Typography variant={fontSize} sx={{ml: 1, color: 'red'}}>{`${state.unReadCount}`}</Typography>
                        <Typography variant={fontSize} >{`)`}</Typography>
                    </Box>
                    {/* 페이징 */}
                    <Box sx={{display: 'flex', justifyContent: 'center', mt: 1, mb: 1, width: 1,}}>
                        <Stack spacing={1} sx={{width: 1, alignItems: 'center'}}>

                            {/* 테이블*/}
                            {
                                <NoteListTable id={props.id}
                                               clickNote={clickNote}
                                               checkDeleteNote={checkDeleteNote}
                                               deleteNoteIdList={state.deleteNoteIdList}
                                               noteHistoryList={state.noteHistoryList}/>
                            }

                            {/* 페이징 */}
                            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2, mb: 1}}>
                                <Stack spacing={1}>
                                    <Pagination
                                        count={Math.ceil(state.totalCount / 10)}
                                        variant="outlined"
                                        page={state.page}
                                        shape={'rounded'}
                                        boundaryCount={isMobile ? 0 : 2}
                                        onChange={changePagination}/>
                                </Stack>
                                <FormControl sx={{ml: 2}}>
                                    <InputLabel>페이지</InputLabel>
                                    <Select
                                        value={state.page}
                                        label="페이지"
                                        size={"small"}
                                        onChange={(event) => changePagination(event, 0)}
                                    >
                                        {
                                            new Array(Math.ceil(state.totalCount / 10)).fill(0).map((value, index) => {
                                                return <MenuItem value={index + 1}>{index + 1}</MenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Box>

                            {/* 쪽지 삭제 */}
                            <Box sx={{width: 1, display: 'flex', mt: 2, justifyContent: 'flex-end'}}>
                                <Button variant={'contained'}
                                        color={'error'}
                                        disabled={deleteCount == 0}
                                        onClick={() => deleteNote()}
                                >
                                    <DeleteIcon/>
                                    <Typography>선택 삭제</Typography>
                                </Button>
                            </Box>
                        </Stack>

                    </Box>

                </Stack>
                <NoteContentDialog noteHistory={state.selectedContent}
                                   state={state}
                                   setState={setState}
                                   deleteNote={deleteNote}
                                   type={props.id}/>
            </Box>
        </>
    );
}
